var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import NavigationService from "@ane/core/lib/services/NavigationService";
import { ROUTES } from "./Routes.constants.js";
import "../models/index.js";
import { SegmentLevel } from "../models/MAUI.models.js";
class Util {
  constructor() {
    __publicField(this, "_modulePath", `${ROUTES.metricsAuthoring.root.match.path}`);
    __publicField(this, "_modulePathname", `${ROUTES.metricsAuthoring.root.location.pathname}`);
    __publicField(this, "routes", {
      root: {
        path: () => `${this.path}`,
        url: () => `${this.url}`
      },
      list: {
        path: () => `${this.path}${ROUTES.metricsAuthoring.list.match.path}`,
        url: () => `${this.url}${ROUTES.metricsAuthoring.list.location.pathname}`
      },
      createMetricSet: {
        path: () => `${this.path}${ROUTES.metricsAuthoring.createMetricSet.match.path}`,
        url: () => `${this.url}${ROUTES.metricsAuthoring.createMetricSet.location.pathname}`
      },
      cloneMetricSet: {
        path: () => `${this.path}${ROUTES.metricsAuthoring.cloneMetricSet.match.path}`,
        url: () => `${this.url}${ROUTES.metricsAuthoring.cloneMetricSet.location.pathname}`
      },
      /**
       * Metric set landing page
       */
      viewDrafts: {
        path: () => `${this.path}${ROUTES.metricsAuthoring.viewDrafts.match.path}`,
        url: ({ metricSetName }) => `${this.url}${ROUTES.metricsAuthoring.viewDrafts.location.pathname}/${metricSetName}`
      },
      createDraft: {
        path: () => `${this.path}${ROUTES.metricsAuthoring.createDraft.match.path}`,
        url: ({ metricSetName }) => `${this.url}${ROUTES.metricsAuthoring.createDraft.location.pathname}/${metricSetName}/draft/create`
      },
      /**
       * Production and draft metric set view
       */
      viewMetricSet: {
        path: () => `${this.path}${ROUTES.metricsAuthoring.viewMetricSet.match.path}`,
        url: ({
          metricSetName,
          draftName,
          entityName,
          subEntityName
        }) => {
          let path = !!entityName ? `/${entityName}` : "";
          path += !!subEntityName && !!subEntityName ? `/${subEntityName}` : "";
          return `${this.url}${ROUTES.metricsAuthoring.viewDrafts.location.pathname}/${metricSetName}/draft/${draftName}${path}`;
        }
      },
      editMetricSetEntity: {
        url: ({
          metricSetName,
          draftName,
          entityName,
          subEntityName,
          mode
        }) => {
          let path = !!subEntityName ? `/${subEntityName}` : "";
          path += !!mode ? `/${mode}` : "";
          return `${this.url}${ROUTES.metricsAuthoring.viewDrafts.location.pathname}/${metricSetName}/draft/${draftName}/${entityName}${path}`;
        }
      },
      metricSetup: {
        // path: () => `${this.path}${ROUTES.metricsAuthoring.viewMetricSet.match.path}`,
        url: ({ metricSetName, draftName, view }) => {
          let path = !!view ? `/${view}` : "";
          return `${this.url}${ROUTES.metricsAuthoring.viewDrafts.location.pathname}/${metricSetName}/draft/${draftName}/setup${path}`;
        }
      },
      metricSetConfiguration: {
        // path: () => `${this.path}${ROUTES.metricsAuthoring.viewMetricSet.match.path}`,
        url: ({ metricSetName, draftName, view }) => {
          let path = !!view ? `/${view}` : "";
          return `${this.url}${ROUTES.metricsAuthoring.viewDrafts.location.pathname}/${metricSetName}/draft/${draftName}/configuration${path}`;
        }
      },
      metricHealth: {
        // path: () => `${this.path}${ROUTES.metricsAuthoring.viewMetricSet.match.path}`,
        url: ({ metricSetName, draftName, view }) => {
          let path = !!view ? `/${view}` : "/constant-value-metrics";
          return `${this.url}${ROUTES.metricsAuthoring.viewDrafts.location.pathname}/${metricSetName}/draft/${draftName}/metric-health${path}`;
        }
      },
      createSegment: {
        url: ({ metricSetName, draftName, level }) => {
          const mode = level === SegmentLevel.base ? "create" : "add";
          return `${this.url}${ROUTES.metricsAuthoring.viewDrafts.location.pathname}/${metricSetName}/draft/${draftName}/segment/${mode}`;
        }
      },
      editSegment: {
        url: ({ metricSetName, draftName, segmentName }) => {
          return `${this.url}${ROUTES.metricsAuthoring.viewDrafts.location.pathname}/${metricSetName}/draft/${draftName}/segment/${segmentName}/edit`;
        }
      },
      previewscorecard: {
        // path: () => `${this.path}${ROUTES.metricsAuthoring.viewMetricSet.match.path}`,
        url: ({ metricSetName, draftName, view }) => {
          let path = !!view ? `/${view}` : "/published-versions";
          return `${this.url}${ROUTES.metricsAuthoring.viewDrafts.location.pathname}/${metricSetName}/draft/${draftName}/preview-scorecard${path}`;
        }
      }
    });
  }
  /**
   * React Router regex path
   */
  get path() {
    return `${NavigationService.root.path}${this._modulePath}`;
  }
  /**
   * Pathname used to construct complete URL
   */
  get url() {
    return `${NavigationService.root.url}${this._modulePathname}`;
  }
}
class Opt_In_Util {
  constructor() {
    __publicField(this, "_modulePath", `${ROUTES.metricsAuthoring.opt_in_root.match.path}`);
    __publicField(this, "_modulePathname", `${ROUTES.metricsAuthoring.opt_in_root.location.pathname}`);
    __publicField(this, "routes", {
      root: {
        path: () => `${this.path}`,
        url: () => `${this.url}`
      }
    });
  }
  /**
   * React Router regex path
   */
  get path() {
    return `${NavigationService.root.path}${this._modulePath}`;
  }
  /**
   * Pathname used to construct complete URL
   */
  get url() {
    return `${NavigationService.root.url}${this._modulePathname}`;
  }
}
const MetricsAuthoringRouteUtils = new Util();
const MetricsAuthoringOptInRouteUtils = new Opt_In_Util();
export {
  MetricsAuthoringOptInRouteUtils,
  MetricsAuthoringRouteUtils
};
//# sourceMappingURL=MetricsAuthoringRoute.utils.js.map
